export default "__VITE_ASSET__Dhwi_8hE__"